export default __webpack_public_path__ + "static/media/company_logo.84abc04e.png";